import { get } from 'lodash'

import { getPostureCheckUserEmail } from './postureCheckRowUtils'
import { getEmployeeFullName } from './table.util'

const EMPLOYEE_NAME_FIELDS = new Set(['employeeName', 'name', 'firstName', 'fullName', 'displayName'])

const compareSortValues = (valueA, valueB) => {
  const a = valueA ?? ''
  const b = valueB ?? ''

  if (typeof a === 'string' || typeof b === 'string') {
    return String(a).localeCompare(String(b), undefined, { sensitivity: 'base' })
  }

  if (a < b) {
    return -1
  }

  return a > b ? 1 : 0
}

export const getPostureCheckExportSortValue = (row, field) => {
  if (EMPLOYEE_NAME_FIELDS.has(field)) {
    return getEmployeeFullName(row)
  }

  if (field === 'email') {
    return getPostureCheckUserEmail(row)
  }

  if (field === 'lastAppActivity') {
    return row.lastAppActivity?.activityDate ?? ''
  }

  if (field === 'formattedName') {
    return row.formattedName ?? getEmployeeFullName(row)
  }

  if (field === 'formattedSigninEnabled') {
    return row.formattedSigninEnabled ?? ''
  }

  return get(row, field) ?? ''
}

export const hasPostureCheckExportSort = (sort) => Boolean(sort?.field)

export const sortPostureCheckExportRows = (data, sort) => {
  const rows = Array.isArray(data) ? data : []

  if (!hasPostureCheckExportSort(sort)) {
    return rows
  }

  const { field, order } = sort

  return rows.slice().sort((rowA, rowB) => {
    const valueA = getPostureCheckExportSortValue(rowA, field)
    const valueB = getPostureCheckExportSortValue(rowB, field)

    const comparison = compareSortValues(valueA, valueB)

    return order === 'desc' ? -comparison : comparison
  })
}
